import { combineReducers } from "redux";
import axios from "axios";
import _ from 'lodash';
import { API } from "../../../../const";
import { OPEN_SNACKBAR_ERROR, OPEN_SNACKBAR_SUCCESS } from "../../../../reducers";
import { Service } from "../../../service/service"
import { unAuthorized } from '../../../auth/Auth.ducks'

// Absence actions

export const GET_STAFF_PENDING = "GET_STAFF_PENDING";
export const GET_STAFF_REJECTED = "GET_STAFF_REJECTED";
export const GET_STAFF_FULFILLED = "GET_STAFF_FULFILLED";

export const POST_COPIES_PENDING = "POST_COPIES_PENDING";
export const POST_COPIES_REJECTED = "POST_COPIES_REJECTED";
export const POST_COPIES_FULFILLED = "POST_COPIES_FULFILLED";

export const RESET_WEEK_PENDING = "RESET_WEEK_PENDING";
export const RESET_WEEK_REJECTED = "RESET_WEEK_REJECTED";
export const RESET_WEEK_FULFILLED = "RESET_WEEK_FULFILLED";


const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_STAFF_PENDING:


      return true;
    case GET_STAFF_REJECTED:
    case GET_STAFF_FULFILLED:

      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_STAFF_PENDING:
    case GET_STAFF_FULFILLED:

      return null;
    case GET_STAFF_REJECTED:


      return payload;
    default:
      return null;
  }
};

const data = (state = { "planningStaff": {} }, { type, payload }) => {
  switch (type) {
    case GET_STAFF_FULFILLED:

      return _.isEmpty(payload.data) ? null : payload.data;
    case GET_STAFF_PENDING:

      return null;

    default:
      return state;
  }
};

// Staff combined reducer
export default combineReducers({ loading, error, data });

export const getStaffing = (tok, year, week) => {
  return (dispatch) => {
    dispatch({ type: GET_STAFF_PENDING })
    const response = Service.get(`${API}api/creche/staffings/annees/${year}/semaines/${week}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_STAFF_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_STAFF_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}

export const postCopies = (tok, year, week, data) => {
  return (dispatch) => {
    dispatch({ type: POST_COPIES_PENDING })
    const response = Service.post(`${API}api/creche/staffings/annees/${year}/semaines/${week}/copies`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_COPIES_FULFILLED, payload: res })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_COPIES_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}

export const resetWeek = (tok, year, week) => {
  return (dispatch) => {
    dispatch({ type: RESET_WEEK_PENDING })
    const response = Service.deleteOne(`${API}api/creche/staffings/annees/${year}/semaines/${week}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: RESET_WEEK_FULFILLED, payload: res })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
      dispatch(getStaffing(tok, year, week))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: RESET_WEEK_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}

